module.exports = __webpack_public_path__ + "static/media/funnel-tutorial-8-step 1.97f5635e.svg";